import React, {Component} from 'react';
import heroBg from '../../../assets/images/hero.jpg';
import _ from "lodash";
import {connect} from "react-redux";

class Hero extends Component {
    getTitle = () => {
        const {item, user} = this.props;

        let title = item.data && item.data.title;

        if (!title || title === '') {
            title = item.data.fallBackTitle || '';
        }

        if (user.isLoggedIn) {
            if (typeof title !== 'string') {
                title = title.toString();
            }

            title = title.replace(/\[FIRSTNAME\]/g, user.given_name);
            title = title.replace(/\[LASTNAME\]/g, user.family_name);
        }

        return title;
    };

    getContentFieldValue = (fieldDefinitionKey) => {
        const {contentFields} = this.props;
        const data = _.find(contentFields, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    render() {
        const {item} = this.props;
        const image = item.data.image;
        const title = this.getTitle();

        return (
            <section className="component hero" style={{backgroundImage: `${heroBg ? `url(${heroBg})` : 'none'}`}}>
                <section className="hero--inner">
                    <h1>{title}</h1>
                </section>
                {image &&
                <img src={image.mediaUrl} alt={title} style={{ maxHeight: '200px' }}/>
                }
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(Hero);



// WEBPACK FOOTER //
// ./src/frontend/components/Fields/Hero/Hero.js